import { SwalMessage } from "../js/Tools";

var HotelSearching = function () {


    let searchWhereInput;
    const searchResult = document.querySelector('#hotel-searching [data-search-result]');

    // const searchItemTemplate = function (item) {
    //     return '<div class="item"><div class="title">${item.name}, ${item.district}</div><small>${item.district}, ${item.city}</small></div>';
    // }

    const searchItemTemplate = document.querySelector('[data-search-item-template]')

    const searchWhere = function () {
        if (searchWhereInput) {

            searchWhereInput.addEventListener('keyup', function () {
                let searchWhere = this.value;
                if (searchWhere.length > 2) {

                    $.ajax({
                        url: apiUrl + '/hotel-searching',
                        type: 'POST',
                        dataType: 'json',
                        data: {
                            terms: searchWhere
                        },
                        success: function (response) {

                            searchResult.innerHTML = '';
                            if (response.code == 200) {

                                const rows = response.row;

                                searchResult.classList.remove('d-none');

                                rows?.map((row) => {

                                    let clone = searchItemTemplate.cloneNode(true);

                                    clone.classList.remove('d-none');

                                    if (row.text) {
                                        clone.querySelector('.title').innerText = row.name;
                                        clone.querySelector('small').innerText = row.text;
                                    } else {
                                        clone.querySelector('.title').innerText = row.name + ', ' + row.district;
                                        if (row.city != null && row.city != '') {
                                            clone.querySelector('small').innerText = row.district + ', ' + row.city;
                                        } else {
                                            clone.querySelector('small').innerText = row.district;
                                        }
                                    }

                                    clone.addEventListener('click', function () {
                                        if(row.district){
                                            searchWhereInput.value = row.name + ', ' + row.district;
                                        }
                                        else{
                                            searchWhereInput.value = row.name;
                                        }
                                        searchResult.classList.add('d-none');
                                    });

                                    searchResult.appendChild(clone);

                                });

                            } else {
                                searchResult.classList.add('d-none');
                            }

                        }
                    });
                } else {
                    searchResult.classList.add('d-none');
                }
            }
            );
        }
    }




    return {
        init: function () {
            if (document.querySelector('[data-search-where]')) {
                searchWhereInput = document.querySelector('[data-search-where]');

                searchWhere();
            }
        }
    }
}();

$(function () {
    HotelSearching.init();
});